const features = [
  {
    icon: "ri-download-cloud-2-fill",
    title: "一键缓存下载",
    desc: "找到喜欢的漫画，点一下即可把整话或整部缓存到本地，下载快、批量管理方便。",
  },
  {
    icon: "ri-flight-takeoff-fill",
    title: "离线畅读不耗流",
    desc: "缓存完成后无需网络，地铁、飞机、深山旅行都能随时翻看，数据流量零消耗。",
  },
  {
    icon: "ri-archive-fill",
    title: "全集打包收藏",
    desc: "把追了很多年的老番一次性打包进收藏夹，整部作品整整齐齐，长期留存不丢失。",
  },
  {
    icon: "ri-folders-fill",
    title: "智能收藏夹",
    desc: "按作品、类型、更新和阅读进度自动归类，支持批量整理与一键打包，书架一目了然。",
  },
  {
    icon: "ri-device-line",
    title: "多端同步",
    desc: "手机、平板、电脑全平台适配，收藏与阅读进度安全同步，换设备也不怕。",
  },
  {
    icon: "ri-settings-4-fill",
    title: "画质随心调",
    desc: "标清、高清、原图自由切换，按需平衡画质与空间占用，看得清楚又不占地方。",
  },
];

export default function Features() {
  return (
    <section id="features" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-semibold uppercase tracking-widest text-primary-600">
            核心功能
          </p>
          <h2 className="mt-3 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
            为离线看漫画而生
          </h2>
          <p className="mt-4 text-base text-foreground-600">
            围绕下载缓存、全集打包与离线收藏三大场景，把整部漫画稳稳装进你的设备。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((f) => (
            <article
              key={f.title}
              className="group rounded-lg border border-background-200 bg-background-100 p-6 transition-colors hover:border-primary-200"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-500/10 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${f.icon} text-2xl`} aria-hidden="true"></i>
              </div>
              <h3 className="mt-5 text-lg font-bold text-foreground-900">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}